// src/website/components/EventHero.jsx
import React from 'react';

const EventHero = ({ event }) => {
  return (
    <section className="event-hero">
      <div className="hero-background">
        {event.eventPoster && (
          <img 
            src={`${process.env.REACT_APP_API_URL}/api/storage/${event.eventPoster}`} 
            alt={event.name}
            className="hero-image"
          />
        )}
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <div className="container">
          <h1 className="hero-title">{event.name}</h1>
          <p className="hero-description">{event.description}</p>
          
          <div className="hero-meta">
            <div className="meta-item">
              <span className="meta-label">Date</span>
              <span className="meta-value">
                {new Date(event.startDate).toLocaleDateString()} 
                {event.endDate && ` - ${new Date(event.endDate).toLocaleDateString()}`}
              </span>
            </div>
            
            {event.venues?.[0] && (
              <div className="meta-item">
                <span className="meta-label">Venue</span>
                <span className="meta-value">
                  {event.venues[0].venueName}, {event.venues[0].city}
                </span>
              </div>
            )}
          </div>

          <div className="hero-actions">
            <button className="btn btn-primary">Register Now</button>
            <button className="btn btn-secondary">View Agenda</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventHero;